import { useTemplateContext } from 'modules/campaigns/editor/context';
import { EmbeddedPrimaryContent } from 'modules/campaigns/editor/types';
import { CampaignFormField, ReadOnlyField } from '../../FormFields';

import { SectionHeader, SectionWrapper } from '../Sections.styled';

export const CUSTOM_TEXT_FIELDS_TEST_ID = 'custom-text-fields-section';

export const CustomTextFieldsSection = () => {
  const { templateAndContent } = useTemplateContext();
  const { primaryContent = {} } = templateAndContent;
  const { elements } = primaryContent as EmbeddedPrimaryContent;
  const textFields = elements?.text;

  return textFields?.length ? (
    <SectionWrapper data-test={CUSTOM_TEXT_FIELDS_TEST_ID}>
      <SectionHeader>Custom text fields</SectionHeader>
      {textFields?.map((text) => (
        <CampaignFormField key={text.id} labelText={text.label} $removeMarginBottom>
          <ReadOnlyField name={text.id}>{text.text}</ReadOnlyField>
        </CampaignFormField>
      ))}
    </SectionWrapper>
  ) : null;
};
